import { TCalculatorData, TCalculatorError, TItem } from '@libs/types';

export enum InputEnum {
    FROM_INPUT = 'fromInput',
    TO_INPUT = 'toInput',
    CODE = 'code',
    INPUT_VALUE = 'inputValue',
}

export enum ActionNameEnum {
    increaseLimit = 'increaseLimit',
    onChangeDeliveryOptions = 'onChangeDeliveryOptions',
    onChangeTransferOptions = 'onChangeTransferOptions',
    onAddCode = 'onAddCode',
    onRemoveCode = 'onRemoveCode',
    onCalculate = 'onCalculate',
    submit = 'submit',
}

export type TResult = {
    fromCurrencyList: TItem[];
    toCurrencyList: TItem[];
};
export type TErrorsResult = {
    fromInput?: TCalculatorError;
    toInput?: TCalculatorError;
    code?: TCalculatorError;
};

export enum CurrencyDropdownEnum {
    FROM_CURRENCY = 'fromCurrency',
    TO_CURRENCY = 'toCurrency',
    INPUT_CURRENCY = 'inputCurrency',
}

export type TResultServerCalculationFunc = {
    value?: TCalculatorData['value'];
    errors: TErrorsResult;
};
export type TServerCalculationFunc = (
    value: string,
    name: string,
    isFrom?: boolean,
    actionName?: ActionNameEnum,
) => Promise<TResultServerCalculationFunc | undefined>;
export type THandleUpdateValue = (clearValue: string, name: string, isFromFlag?: boolean) => void;
export type THandleButtonClick = () => void;
